import React from 'react';
import styled from 'styled-components';
import Icon from 'js/components/common/Icon';
import { upTo } from 'js/services/MediaQuery';
import { inject } from 'mobx-react';

const Container = styled.div`
  align-self: start;
  justify-self: center;
  user-select: none;
  height: 100%;
`;

const Image = styled.img`
  max-width: 100%;
  max-height: 100%;
`;

const IconLogo = styled(Icon)`
  font-size: 2.5rem;

  ${upTo('sm')`
    font-size: 2rem;
  `}
`;

export default inject('model')(({ logo_type, logo, model: transaction }) => (
  <Container>
    {transaction.logo_type === 'credit_card' ? (
      <Image src={`/images/payment-icons/${transaction.logo}.png`} />
    ) : transaction.logo_type === 'bank_institution' ? (
      <Image src={transaction.logo_src} />
    ) : transaction.logo_type === 'bank_default' ? (
      <IconLogo name="university" />
    ) : transaction.logo_type === 'internal' ? (
      <IconLogo name="user-circle" />
    ) : null}
  </Container>
));
